import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { CompanyParamsProvider } from "../Context/companyContext";
import { VersionProvider } from "../Context/hasBetaActiveContext";
import { PoupProvider } from "../Context/hasPopupActiveContext";
import { PermissionProvider } from "../Context/permissionContext";
import { AuthProvider } from "./AuthProvider";
import { ClientProvider } from "./ClientProvider";
import { QueryProvider } from "../providers/QueryProvider";
import { InactivityModal } from "../components-v2/InactivityModal";


interface AppProvideHookInterface {
  children: ReactNode;
}

function AppProvide({ children }: AppProvideHookInterface) {
  const location = useLocation();

  const isLoginPage = location.pathname === "/";

  return (
    <AuthProvider>
      {!isLoginPage ? (
        <QueryProvider>
          <ClientProvider>
            <PermissionProvider>
              <PoupProvider>
                <VersionProvider>
                  <CompanyParamsProvider>
                    {children}
                    <InactivityModal /> 
                  </CompanyParamsProvider>
                </VersionProvider>
              </PoupProvider>
            </PermissionProvider>
          </ClientProvider>
        </QueryProvider>
      ) : (
        <>{children}</>
      )}
    </AuthProvider>
  );
}

export default AppProvide;